import ApiClientError from '@webapp/utils/client-error';
import { getToken } from './auth';

const API_DOMAIN = process.env.REACT_APP_API_URL;

export type ApiClient = (
  endpoint: string,
  method: string,
  data?: any,
  signal?: AbortSignal
) => Promise<Response>;

export const getFullUrl = (service: string, endpoint: string) =>
  `${API_DOMAIN}${service}${endpoint}`;

export const CallApi =
  (service: string): ApiClient =>
  async (
    endpoint: string,
    method: string,
    data?: any,
    signal?: AbortSignal
  ) => {
    const token = await getToken();

    if (!token) {
      throw new Error('Missing token!');
    }

    const headers = new Headers();
    headers.append('Authorization', token);
    headers.append('Content-Type', 'application/json');

    const params: RequestInit = {
      method,
      headers,
      signal,
    };

    if (data) {
      if (method !== 'GET') {
        params.body = JSON.stringify(data);
      } else {
        endpoint = `${endpoint}?${new URLSearchParams(data).toString()}`;
      }
    }

    return fetch(getFullUrl(service, endpoint), params);
  };

export const CallPublicApi =
  (service: string): ApiClient =>
  async (
    endpoint: string,
    method: string,
    data?: any,
    signal?: AbortSignal
  ) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const params: RequestInit = {
      method,
      headers,
      signal,
    };

    if (data) {
      if (method !== 'GET') {
        params.body = JSON.stringify(data);
      } else {
        endpoint = `${endpoint}?${new URLSearchParams(data).toString()}`;
      }
    }

    return fetch(getFullUrl(service, endpoint), params);
  };

export const handleResponse = async (response: Response) => {
  const data = await response.text();

  if (!response.ok) {
    throw new Error(data);
  }

  return data;
};

export const handleJSONResponse = async <T = any>(response: Response) => {
  const data = await response.json();

  if (!response.ok) {
    throw new ApiClientError(data.code, data);
  }

  return parseCommonFields(data) as T;
};

const parseCommonFields = (data: any): any => {
  if (typeof data === 'string') {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map((d) => parseCommonFields(d));
  }

  if ('created_at' in data) {
    data.created_at = new Date(data.created_at);
  }

  if ('updated_at' in data) {
    data.updated_at = new Date(data.updated_at);
  }

  return data;
};
